module.exports = __webpack_public_path__ + "img/arrow-left.3c257020.svg";